import type { ReactNode } from "react";
import ChevronRightRounded from "@mui/icons-material/ChevronRightRounded";
import { Box, ListItem, ListItemButton, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * A settings-style navigation row: icon, title, optional current value, and a
 * chevron. Render inside a MUI <List>. `to` is an in-app route; `href` leaves
 * the app (another workspace).
 */
export function NavRow({
  icon,
  label,
  value,
  to,
  href,
}: {
  icon: ReactNode;
  label: string;
  value?: ReactNode;
  to?: string;
  href?: string;
}) {
  const link = to ? { component: RouterLink, to } : { component: "a" as const, href };
  return (
    <ListItem disablePadding>
      <ListItemButton
        {...link}
        sx={{ gap: 2, px: { xs: 0.5, sm: 1 }, py: 1, minHeight: 52, borderRadius: 2 }}
      >
        <Box aria-hidden sx={{ display: "flex", color: "text.primary" }}>
          {icon}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: "0.9375rem", fontWeight: 600, overflowWrap: "anywhere" }}>
            {label}
          </Typography>
          {value ? (
            <Typography noWrap variant="body2" color="text.secondary">
              {value}
            </Typography>
          ) : null}
        </Box>
        <ChevronRightRounded color="action" aria-hidden />
      </ListItemButton>
    </ListItem>
  );
}
